/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 根据token获取授权码或者根据授权码获取token信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class H5TokenParams {
  constructor(public code?: string) {}
}

export default async function (
  params: H5TokenParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.H5Token;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/h5-token`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
